import { createSlice } from '@reduxjs/toolkit'

const downloadSlice = createSlice({
  name: 'download',
  initialState: {
    tasks: []
  },
  reducers: {
    addTask: (state, action) => {
      state.tasks.push(action.payload)
    },
    removeTask: (state, action) => {
      state.tasks = state.tasks.filter((item) => item.id !== action.payload)
    },
    clearTasks: (state) => {
      state.tasks = []
    },
    updateTask: (state, action) => {
      const { id } = action.payload
      const index = state.tasks.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.tasks[index] = { ...state.tasks[index], ...action.payload }
      }
    }
  }
})

export const { addTask, removeTask, clearTasks, updateTask } = downloadSlice.actions

export default downloadSlice.reducer